import React, { Suspense, lazy, useEffect, useState } from 'react';
import { MarketProvider } from './contexts/MarketContext';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Footer } from './components/Footer';

/**
 * Everything below the first viewport is split into a separate chunk so the
 * hero paints as fast as possible on mobile. The chunk is requested as soon as
 * the browser is idle (and immediately on any scroll/touch), so the content is
 * already in place by the time the visitor scrolls — nothing visual changes.
 */
const BelowFold = lazy(() => import('./components/BelowFold').then(m => ({
  default: m.BelowFold
})));
export function App() {
  const [loadRest, setLoadRest] = useState(false);
  useEffect(() => {
    if (loadRest) return;
    const start = () => setLoadRest(true);
    type IdleWindow = Window & {
      requestIdleCallback?: (cb: () => void, opts?: {
        timeout?: number;
      }) => number;
    };
    const w = window as IdleWindow;
    let timeout: number | undefined;
    if (typeof w.requestIdleCallback === 'function') {
      w.requestIdleCallback(start, {
        timeout: 800
      });
    } else {
      timeout = window.setTimeout(start, 200);
    }
    window.addEventListener('scroll', start, {
      passive: true,
      once: true
    });
    window.addEventListener('touchstart', start, {
      passive: true,
      once: true
    });
    return () => {
      if (timeout !== undefined) window.clearTimeout(timeout);
      window.removeEventListener('scroll', start);
      window.removeEventListener('touchstart', start);
    };
  }, [loadRest]);
  return <MarketProvider data-id="element-0" data-mp="38lrp0dimj2h5">
      <div className="w-full bg-cream font-sans" data-id="element-1" data-mp="38l8gfnev5qfs">
        <TopBar data-id="element-2" data-mp="38kgm0fx05yr3" />
        <main data-id="element-3" data-mp="38o4edbqpof48">
          <Hero data-id="element-4" data-mp="3dkl4gbhh13jy" />
          {loadRest && <Suspense fallback={null} data-id="element-5" data-mp="3dlnwimqj5c1g">
              <BelowFold data-id="element-6" data-mp="3dii716dzo857" />
            </Suspense>}
        </main>
        {loadRest && <Footer data-id="element-7" data-mp="nxn5hsc273nd" />}
      </div>
    </MarketProvider>;
}